// Вопрос «Ваш город …?» при первом заходе (кадр 3956:114950 «Первый заход на
// сайт — разрешить геоданные»). Ответ запоминаем в localStorage: «Да, оставить»
// или выбранный вручную город больше не спрашиваем. Закрыли вопрос, не ответив,
// — не спрашиваем до перезагрузки (`dismissed` живёт только в памяти).
import { create } from "zustand";

const KEY = "osmix-city-confirmed";

const readConfirmed = (): boolean => {
	try {
		return typeof window !== "undefined" && window.localStorage.getItem(KEY) === "1";
	} catch {
		return false;
	}
};

type CityPromptState = {
	confirmed: boolean;
	dismissed: boolean;
	confirm: () => void;
	dismiss: () => void;
};

export const useCityPrompt = create<CityPromptState>((set) => ({
	confirmed: readConfirmed(),
	dismissed: false,
	confirm: () => {
		try {
			window.localStorage.setItem(KEY, "1");
		} catch {
			// хранилище недоступно (приватный режим) — помним до перезагрузки
		}
		set({ confirmed: true });
	},
	dismiss: () => set({ dismissed: true }),
}));
